import { NATIONAL_ID_TRANSLATIONS } from '../../constants'
import type { NationalIdCountries } from '../../types'

export function getNationalIdTranslation(country: NationalIdCountries) {
  return NATIONAL_ID_TRANSLATIONS[country]
}
